import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'
import requestConfig from 'app/requests/ServiceCenter/ServiceCenterMonitoring.requests'
import {
    DryStorage,
} from '../serviceCenters.types'

const useGetDryStorage = ({
    serviceCenter,
}: {
    serviceCenter: {id: number}
}) => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    } = useRequest<DryStorage>({
        key: RequestKeys.getDryStorage,
        params: {
            params: {
                serviceCenter,
            },
        },
        requestFunc: RequestFn.getEntity(requestConfig.getDryStorage),
        enabled: Boolean(serviceCenter?.id),
    })

    return {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
        invalidate,
    }
}

export default useGetDryStorage
